module.exports = __webpack_public_path__ + "img/13-white.dcc9924b.svg";